import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';

export interface GuestProfileBase {
  uid: string;
  name: string | null;
  eventId: string;
  hall: string | null;
  path?: string | null;
}

@Injectable({ providedIn: 'root' })
export class FireGuestAccessService {
  constructor(private afs: AngularFirestore) {}

  /**
   * Called from the landing page AFTER the user checks consent and enters name.
   * Creates/updates a single document per uid with consent info.
   */
  async recordConsent(p: GuestProfileBase & { consent: boolean }): Promise<void> {
    const now = firebase.firestore.FieldValue.serverTimestamp();
    await this.afs.collection('live_access').doc(p.uid).set(
      {
        uid: p.uid,
        name: p.name ?? null,
        eventId: p.eventId,
        hall: p.hall ?? null,
        consent: !!p.consent,
        consentAt: now,
        // firstSeen is set on first write only; lastSeen is always updated
        firstSeen: now,
        lastSeen: now,
        lastPath: p.path ?? null,
        sessions: 0, // will be incremented on live page
      },
      { merge: true }
    );
  }

  /**
   * Called on the live page when the user lands (and optionally on intervals).
   * Upserts minimal fields and bumps counters/timestamps.
   */
  async touchLiveSession(p: GuestProfileBase): Promise<void> {
    const now = firebase.firestore.FieldValue.serverTimestamp();
    await this.afs.collection('live_access').doc(p.uid).set(
      {
        uid: p.uid,
        name: p.name ?? null, // keep latest provided name
        eventId: p.eventId,
        hall: p.hall ?? null,
        lastSeen: now,
        lastPath: p.path ?? null,
        joinedAt: now, // only first time due to merge behavior in some UIs; ok to keep
        sessions: firebase.firestore.FieldValue.increment(1),
      },
      { merge: true }
    );
  }
}
